import { getTaskContact } from "web_myplann/Activities/Helpers/getTaskContact";
import { useAgentQuery } from "web_myplann/Api/Advisor/useAgentQuery";
import { useTaskQuery } from "web_myplann/Api/Tasks/useTaskQuery";
import { useTaskWorkflowsQuery } from "web_myplann/Api/Tasks/useTaskWorkflowsQuery";

export const useTaskDetail = (taskId: number | null) => {
	const { data: taskData, isFetching: isTaskFetching } = useTaskQuery(taskId);
	const { data: taskWorkflowsData, isFetching: isTaskWorkflowsFetching } =
		useTaskWorkflowsQuery(taskId);

	const { data: contact } = useAgentQuery(
		taskData ? getTaskContact(taskData).id : undefined,
	);

	return {
		task: taskData ?? undefined,
		phases: taskWorkflowsData?.items ?? [],
		isLoading: isTaskFetching || isTaskWorkflowsFetching,
		isNotFound: taskData === null,
		contact,
	};
};
